import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPayeeQuickInfoMulticompany extends Layout {
    citystate1: CityState;
    panelPayeeInfo: Panel;
    sourceDriverPayeeMulticompany: DataSource;
    textboxAddress: Textbox;
    textboxContactmobilePhone: Textbox;
    textboxContactname: Textbox;
    textboxContactphone: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
}
